export default __webpack_public_path__ + "static/media/Group457.dd53b79a.png";